import React, { useEffect, useState, useCallback } from 'react';
import { Row, Col, Layout } from 'antd';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';
import AppHeaderHomePageTemplate from '../Organism/AppHeaderHomePageTemplate';
import LeaderBoardComponent from '../Organism/LeaderBoardComponent';
const { Content } = Layout;

const LeaderBoard: React.FC = () => {
  const { instance, accounts } = useMsal();

  const callMsGraph = async (token: any) => {
    const headers = new Headers();
    headers.append("Authorization", `Bearer ${token}`);
    const response = await fetch(`https://graph.microsoft.com/v1.0/me?`, {
      method: "GET",
      headers,
    }).then((response) => response.json());
    return response;
  };

  const fetchToken = async () => {
    const res = await instance.acquireTokenSilent({
      ...loginRequest,
      account: accounts[0]
    });
    return res.idToken;
  };

  useEffect(() => {
    fetchToken();
  }, []);

  return (
    <Layout style={{ backgroundColor: 'white' }}>
      <AppHeaderHomePageTemplate />
      <Content>
        <LeaderBoardComponent />
      </Content>
    </Layout>
  );
};
export default LeaderBoard;